export { default } from './LayoutContent';
